{
  "version": 1,
  "asset_id": "46b54ae8-f023-4ac4-9339-c95c4163b706",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/46b54ae8-f023-4ac4-9339-c95c4163b706/bypass-revision-completed-pouch-es-640.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/46b54ae8-f023-4ac4-9339-c95c4163b706/bypass-revision-completed-pouch-es-640.webp",
  "original_filename": "bypass-revision-completed-pouch-es-640.webp",
  "size": 27688,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:37:42Z"
}
